import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_form_group = _resolveComponent("form-group")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_form_group, _mergeProps(_ctx.$props, {
      modelValue: _ctx.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
      class: ["d-grid", { 'no-click': _ctx.attributes.disabled }],
      "index-position": _ctx.indexPosition >= 0 ? _ctx.indexPosition : -1,
      parent: _ctx.attributes.name || _ctx.parent,
      "view-mode": _ctx.componentViewMode,
      path: _ctx.path
    }), null, 16, ["modelValue", "class", "index-position", "parent", "view-mode", "path"]),
    (_ctx.serverErrors.length)
      ? (_openBlock(), _createElementBlock("ul", {
          key: 0,
          class: _normalizeClass(["mb-0", { 'mt-1': _ctx.serverErrors.length }])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.serverErrors, (error, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: `${_ctx.attributes.name}-error-${index}`,
              class: "text-danger fw-bold mb-0"
            }, [
              _createElementVNode("div", { innerHTML: error }, null, 8, _hoisted_1)
            ]))
          }), 128))
        ], 2))
      : _createCommentVNode("", true)
  ]))
}